import styled from 'styled-components';

export const CellWrapperStyled = styled.div`
  display: flex;
  min-height: 40px;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  justify-content: center;
`;
